"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("../Error/WidgetError");
const PluginDefinition_1 = require("./PluginDefinition");
/**
 * Compiler pass that injects plugins in respective managers.
 */
class PluginCompilerPass {
    /**
     * Creates the plugin compiler pass.
     *
     * @param {PluginDefinition[]} plugins
     */
    constructor(plugins) {
        this.plugins = plugins;
    }
    /**
     * @inheritDoc
     */
    process(container) {
        const pluginsPerType = {};
        // Partition plugins per their types.
        this.plugins.forEach((def) => {
            if (!(def instanceof PluginDefinition_1.default)) {
                throw new WidgetError_1.default(`Plugin definition class '${def.constructor.name}' does not implement PluginDefinition.`);
            }
            const type = def.constructor.getType();
            pluginsPerType[type] = pluginsPerType[type] || [];
            pluginsPerType[type].push(def);
        });
        const pluginManagers = container.findTaggedDefinitions("plugin_manager");
        // Inject the plugin definitions into their plugin manager.
        let definition;
        for (definition of Object.values(pluginManagers)) {
            const tagData = definition.getTag("plugin_manager");
            if (!tagData.type) {
                throw new WidgetError_1.default(`Missing type tag data for '${definition.getId()}' plugin manager.`);
            }
            definition.pushArgument(pluginsPerType[tagData.type] || []);
            delete pluginsPerType[tagData.type];
        }
        // Break for any unknown plugin definition.
        let unknownPlugins = Object.keys(pluginsPerType);
        if (unknownPlugins.length) {
            throw new WidgetError_1.default(`Unknown plugin types: '${unknownPlugins.join(", ")}'.`);
        }
    }
}
exports.default = PluginCompilerPass;
